import React, { useState, useEffect } from 'react';

import TableRow from '../TableRow/TableRow';

import Svg from "../../../src/assets/icons/icons.js"

import {
  TableSt,
  LineSt,
  LineItemSt,
  WrapTableSt,
} from './style.js'

import i18n from "i18next";

// сравнение дат вида dd.mm.yyyy
const toDate = (str) => Date.parse(str.slice(3, 6) + str.slice(0, 3) + str.slice(6, 10));

const Table = ({ type, dataProject, recommendations, dopMaterials, query }) => {
  const [dataProjectChange, setDataProjectChange] = useState("");
  const [tooltipe, setTooltipe] = useState(false);
  const [tooltipeRequest, setTooltipeRequest] = useState(false);
  const [bottom, setBottom] = useState(false);

  const tooltipeOpen = (id) => {
    setTooltipe(id);
    setTooltipeRequest(id);
    if (tooltipe === id) {
      setTooltipe(false);
      setTooltipeRequest(false);
    }
    if (tooltipeRequest === id) {
      setTooltipeRequest(false);
    }
  };

  // componentDidUpdate: закрытие тултипа по клику снаружи
  useEffect(() => {
    if (!tooltipe) return undefined;

    const tooltipeOutside = () => { setTooltipe(false) };
    document.addEventListener('click', tooltipeOutside);
    return () => { document.removeEventListener('click', tooltipeOutside) };
  }, [tooltipe]);

  //сортировка
  const _sortOfData = (sortType) => {
    const reverse = dataProjectChange === sortType;

    switch (sortType) {
      case "project":
        if (reverse) {
          dataProject.all.sort((a, b) => {
            if (a.project.title > b.project.title) {
              return -1;
            }
          })
          setBottom(sortType);
        } else {
          dataProject.all.sort((a, b) => {
            if (a.project.title < b.project.title) {
              return -1;
            }
          })
        }
        break;

      case "status":
        if (reverse) {
          dataProject.all && dataProject.all.sort((a, b) => {
            if (a.contract.status > b.contract.status) {
              return -1;
            }
          });
          setBottom(sortType);
        } else {
          dataProject.all && dataProject.all.sort((a, b) => {
            if (a.contract.status < b.contract.status) {
              return -1;
            }
          });
        }
        break;

      case "start":
        if (reverse) {
          dataProject.all && dataProject.all.sort((a, b) => {
            if (toDate(a.contract.date_start) > toDate(b.contract.date_start)) {
              return -1;
            }
          });
          setBottom(sortType);
        } else {
          dataProject.all && dataProject.all.sort((a, b) => {
            if (toDate(a.contract.date_start) < toDate(b.contract.date_start)) {
              return -1;
            }
          });
        }
        break;

      case "end":
        if (reverse) {
          dataProject.all && dataProject.all.sort((a, b) => {
            if (toDate(a.contract.date_end) > toDate(b.contract.date_end)) {
              return -1;
            }
          });
          setBottom(sortType);
        } else {
          dataProject.all && dataProject.all.sort((a, b) => {
            if (toDate(a.contract.date_end) < toDate(b.contract.date_end)) {
              return -1;
            }
          });
        }
        break;

      case "contract":
        if (reverse) {
          dataProject.all && dataProject.all.sort((a, b) => {
            if (a.contract.number > b.contract.number) {
              return -1;
            }
          });
          setBottom(sortType);
        } else {
          dataProject.all && dataProject.all.sort((a, b) => {
            if (a.contract.number < b.contract.number) {
              return -1;
            }
          });
        }
        break;

      case "specification":
        if (reverse) {
          dataProject.all && dataProject.all.sort((a, b) => {
            if (a.contract.specification > b.contract.specification) {
              return -1;
            }
          });
          setBottom(sortType);
        } else {
          dataProject.all && dataProject.all.sort((a, b) => {
            if (a.contract.specification < b.contract.specification) {
              return -1;
            }
          });
        }
        break;

      case "dopStatus":
        if (reverse) {
          dopMaterials.all && dopMaterials.all.sort((a, b) => {
            if (a.status > b.status) {
              return -1;
            }
          });
          setBottom(sortType);
        } else {
          dopMaterials.all && dopMaterials.all.sort((a, b) => {
            if (a.status < b.status) {
              return -1;
            }
          });
        }
        break;

      case "dop":
        if (reverse) {
          dopMaterials.all && dopMaterials.all.sort((a, b) => {
            if (a.project.title > b.project.title) {
              return -1;
            }
          });
          setBottom(sortType);
        } else {
          dopMaterials.all && dopMaterials.all.sort((a, b) => {
            if (a.project.title < b.project.title) {
              return -1;
            }
          });
        }
        break;

      case "request":
        if (reverse) {
          query.all && query.all.sort((a, b) => {
            if (a.project.title > b.project.title) {
              return -1;
            }
          });
          setBottom(sortType);
        } else {
          query.all && query.all.sort((a, b) => {
            if (a.project.title < b.project.title) {
              return -1;
            }
          });
        }
        break;

      case "requestStatus":
        if (reverse) {
          query.all && query.all.sort((a, b) => {
            if (a.status > b.status) {
              return -1;
            }
          });
          setBottom(sortType);
        } else {
          query.all && query.all.sort((a, b) => {
            if (a.status < b.status) {
              return -1;
            }
          });
        }
        break;

      case "requestDate":
        if (reverse) {
          query.all && query.all.sort((a, b) => {
            if (toDate(a.date) > toDate(b.date)) {
              return -1;
            }
          });
          setBottom(sortType);
        } else {
          query.all && query.all.sort((a, b) => {
            if (toDate(a.date) < toDate(b.date)) {
              return -1;
            }
          });
        }
        break;

      case "recommend":
        if (reverse) {
          recommendations && recommendations.sort((a, b) => {
            if (a.title > b.title) {
              return -1;
            }
          });
          setBottom(sortType);
        } else {
          recommendations && recommendations.sort((a, b) => {
            if (a.title < b.title) {
              return -1;
            }
          });
        }
        break;

      case "recommend-start":
        if (reverse) {
          recommendations && recommendations.sort((a, b) => {
            if (new Date(a.publish_at) > new Date(b.publish_at)) {
              return -1;
            }
          });
          setBottom(sortType);
        } else {
          recommendations && recommendations.sort((a, b) => {
            if (new Date(a.publish_at) < new Date(b.publish_at)) {
              return -1;
            }
          });
        }
        break;

      case "recommend-end":
        if (reverse) {
          recommendations && recommendations.sort((a, b) => {
            if (new Date(a.expires_at) > new Date(b.expires_at)) {
              return -1;
            }
          });
          setBottom(sortType);
        } else {
          recommendations && recommendations.sort((a, b) => {
            if (new Date(a.expires_at) < new Date(b.expires_at)) {
              return -1;
            }
          });
        }
        break;

      default:
    }

    if (reverse) {
      setDataProjectChange("");
    }
    else {
      setDataProjectChange(sortType);
      setBottom("");
    }
  };

  return (
    <WrapTableSt>
      <TableSt className={type === "profileRecommend" ? "recommend" : ""}>
        {/*таблица для вкладки проекты*/}
        {type === "profileProject" &&
          <>
            {/*Заголовок*/}
            <LineSt className="header">
              <LineItemSt widthSt="24" className="profile-project" >
              </LineItemSt>
              <LineItemSt widthSt="246" className={dataProjectChange === "project" ? "profile-project active" : "profile-project"} bottom={bottom === "project" ? "90" : ""} onClick={() => _sortOfData("project")}>
                <Svg className={bottom === "project" ? "arrow-rotate" : ""} type="arrow_downward" width="24" height="24" />
                <span>{i18n.t(`profile.project`)}</span>
              </LineItemSt>
              <LineItemSt widthSt="100" className={dataProjectChange === "status" ? "profile-project active" : "profile-project"} onClick={() => _sortOfData("status")}>
                <Svg className={bottom === "status" ? "arrow-rotate" : ""} type="arrow_downward" width="24" height="24" />
                <span>{i18n.t(`profile.status`)}</span>
              </LineItemSt>
              <LineItemSt widthSt="105" className={dataProjectChange === "start" ? "profile-project active" : "profile-project"} onClick={() => _sortOfData("start")}>
                <Svg className={bottom === "start" ? "arrow-rotate" : ""} type="arrow_downward" width="24" height="24" />
                <span>{i18n.t(`profile.period_s`)}</span>
              </LineItemSt>
              <LineItemSt widthSt="105" className={dataProjectChange === "end" ? "profile-project active" : "profile-project"} onClick={() => _sortOfData("end")}>
                <Svg className={bottom === "end" ? "arrow-rotate" : ""} type="arrow_downward" width="24" height="24" />
                <span>{i18n.t(`profile.period_until`)}</span>
              </LineItemSt>
              <LineItemSt widthSt="120" className={dataProjectChange === "contract" ? "profile-project active" : "profile-project"} onClick={() => _sortOfData("contract")}>
                <Svg className={bottom === "contract" ? "arrow-rotate" : ""} type="arrow_downward" width="24" height="24" />
                <span>{i18n.t(`profile.contract`)}</span>
              </LineItemSt>
              <LineItemSt widthSt="100" className={dataProjectChange === "specification" ? "profile-project active" : "profile-project"} onClick={() => _sortOfData("specification")}>
                <Svg className={bottom === "specification" ? "arrow-rotate" : ""} type="arrow_downward" width="24" height="24" />
                <span>{i18n.t(`profile.specification`)}</span>
              </LineItemSt>
              <LineItemSt widthSt="30" className="profile-project points">
                <span>...</span>
              </LineItemSt>
            </LineSt>
            {/*Строки*/}
            {dataProject.all.map((item, i) => {
              return (
                <TableRow
                  type="profileProject"
                  data={item}
                  key={i}
                  tooltipeOpen={(id) => tooltipeOpen(id)}
                  tooltipe={tooltipe}
                  tooltipeRequest={tooltipeRequest}
                  lenght={Object.keys(dataProject.all).length}
                  number={i}
                />
              )
            })
            }
          </>
        }

        {/*таблица для вкладки рекомендации*/}
        {type === "profileRecommend" &&
          <>
            {/*Заголовок*/}
            <LineSt className="header">
              <LineItemSt className="recommend-arrow">
              </LineItemSt>
              <LineItemSt className={dataProjectChange === "recommend" ? " selection active" : "selection"} onClick={() => _sortOfData("recommend")}>
                <Svg className={bottom === "recommend" ? "arrow-rotate" : ""} type="arrow_downward" width="24" height="24" />
                <span>{i18n.t(`profile.selection`)}</span>
              </LineItemSt>
              <LineItemSt className={dataProjectChange === "recommend-start" ? " recommend-start active" : "recommend-start"} onClick={() => _sortOfData("recommend-start")}>
                <Svg className={bottom === "recommend-start" ? "arrow-rotate" : ""} type="arrow_downward" width="24" height="24" />
                <span>{i18n.t(`profile.start`)}</span>
              </LineItemSt>
              <LineItemSt className={dataProjectChange === "recommend-end" ? " recommend-end active" : "recommend-end"} onClick={() => _sortOfData("recommend-end")}>
                <Svg className={bottom === "recommend-end" ? "arrow-rotate" : ""} type="arrow_downward" width="24" height="24" />
                <span>{i18n.t(`profile.completion`)}</span>
              </LineItemSt>
              <LineItemSt className="recommend-mail">
                <Svg type="mail_outline" width="24" height="24" />
              </LineItemSt>
            </LineSt>
            {/*Строки*/}
            {recommendations.map((item, i) => {
              return (
                <TableRow type="profileRecommend" data={item} key={item.id} />
              )
            })
            }
          </>
        }

        {/*таблица для вкладки запросы*/}
        {type === "profileRequest" &&
          <>
            {/*Заголовок*/}
            <LineSt className="header">
              <LineItemSt className="profile-project" widthSt="24">
              </LineItemSt>
              <LineItemSt widthSt="590" className={dataProjectChange === "request" ? "active profile-project" : "profile-project"} onClick={() => _sortOfData("request")}>
                <Svg className={bottom === "request" ? "arrow-rotate" : ""} type="arrow_downward" width="24" height="24" />
                <span>{i18n.t(`profile.project`)}</span>
              </LineItemSt>
              <LineItemSt widthSt="90" className={dataProjectChange === "requestDate" ? "active profile-project" : "profile-project"} onClick={() => _sortOfData("requestDate")}>
                <Svg className={bottom === "requestDate" ? "arrow-rotate" : ""} type="arrow_downward" width="24" height="24" />
                <span>{i18n.t(`profile.date`)}</span>
              </LineItemSt>
              <LineItemSt widthSt="90" className={dataProjectChange === "requestStatus" ? "active profile-project" : "profile-project"} onClick={() => _sortOfData("requestStatus")}>
                <Svg className={bottom === "requestStatus" ? "arrow-rotate" : ""} type="arrow_downward" width="24" height="24" />
                <span>{i18n.t(`profile.status`)}</span>
              </LineItemSt>
              <LineItemSt className="recommend-mail" widthSt="30">
                {/*<span>...</span>*/}
                <Svg type="mail_outline" width="24" height="24" />
              </LineItemSt>
            </LineSt>
            {/*Строки*/}
            {query?.all.map((item, i) => {
              return (
                <TableRow
                  type="profileRequest"
                  tooltipeOpen={(id) => tooltipeOpen(id)}
                  tooltipe={tooltipe}
                  dop={item}
                  key={i}
                  number={i}
                  lenght={Object.keys(query?.all).length}
                />
              )
            })
            }
          </>
        }

        {/*таблица для вкладки доп.материалы*/}
        {type === "profileDop" &&
          <>
            {/*Заголовок*/}
            <LineSt className="header">
              <LineItemSt className="profile-project" widthSt="24">
              </LineItemSt>
              <LineItemSt widthSt="680" className={dataProjectChange === "dop" ? "active profile-project" : "profile-project"} onClick={() => _sortOfData("dop")}>
                <Svg className={bottom === "dop" ? "arrow-rotate" : ""} type="arrow_downward" width="24" height="24" />
                <span>{i18n.t(`profile.project`)}</span>
              </LineItemSt>
              <LineItemSt widthSt="90" className={dataProjectChange === "dopStatus" ? "active profile-project" : "profile-project"} onClick={() => _sortOfData("dopStatus")}>
                <Svg className={bottom === "dopStatus" ? "arrow-rotate" : ""} type="arrow_downward" width="24" height="24" />
                <span>{i18n.t(`profile.status`)}</span>
              </LineItemSt>
              <LineItemSt className="recommend-mail" widthSt="30">
                <Svg type="mail_outline" width="24" height="24" />
              </LineItemSt>
            </LineSt>
            {/*Строки*/}
            {dopMaterials.all && dopMaterials.all.map((item, i) => {
              return (
                <TableRow
                  type="profileDop"
                  tooltipeOpen={(id) => tooltipeOpen(id)}
                  tooltipe={tooltipe}
                  dop={item}
                  key={i}
                  number={i}
                  lenght={Object.keys(dopMaterials.all).length}
                />
              )
            })
            }
          </>
        }

      </TableSt>
    </WrapTableSt>
  );
};

export default Table;
